export function toggleMenu() {
    return {
        type: 'TOGGLE_MENU'
    };
}
